export default class Accordion {
  constructor() {
    this.accordions = [];
    this.moreTextSections = [];
    this.responsiveDetails = [];
    this.init();
  }

  init() {
    this.accordions = document.querySelectorAll('.js-accordion');
    this.moreTextSections = document.querySelectorAll('.js-more-text');
    this.responsiveDetails = document.querySelectorAll('[data-accordion-open-desktop]');
    this.setupAccordionListeners();
    this.setupMoreTextListeners();
    this.setupResponsiveDetails();
    this.setupTreatmentFlowDetails();
  }

  setupTreatmentFlowDetails() {
    document.querySelectorAll('.p-clinic-flow').forEach((flow) => {
      flow.querySelectorAll('.p-clinic-flow__accordion').forEach((details, index) => {
        details.open = index === 0;
      });
    });
  }

  setupResponsiveDetails() {
    if (!this.responsiveDetails.length) return;

    const desktopMedia = window.matchMedia('(min-width: 768px)');
    const syncDetails = (event) => {
      this.responsiveDetails.forEach((details) => {
        details.open = event.matches;
      });
    };

    syncDetails(desktopMedia);
    desktopMedia.addEventListener('change', syncDetails);
  }

  getAccordionTrigger(accordion) {
    const first = accordion.firstElementChild;
    if (!first) return null;

    if (first.matches('h1, h2, h3, h4, h5, h6')) {
      const button = first.querySelector('button');
      if (button) return button;
    }

    return first;
  }

  // アコーディオン処理
  setupAccordionListeners() {
    this.accordions.forEach(accordion => {
      const btn = this.getAccordionTrigger(accordion);
      const content = accordion.querySelector('.js-accordion__content');

      if (!btn || !content) return;

      btn.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');

      btn.addEventListener('click', () => this.toggleAccordion(accordion));
      content.addEventListener('transitionend', (event) => {
        if (event.propertyName === 'max-height' && accordion.classList.contains('is-active')) {
          content.style.maxHeight = 'none';
        }
      });
    });
  }

  toggleAccordion(clicked) {
    const btn = this.getAccordionTrigger(clicked);
    const content = clicked.querySelector('.js-accordion__content');
    const isActive = clicked.classList.contains('is-active');

    if (isActive) {
      btn.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
      content.style.maxHeight = `${content.scrollHeight}px`;

      // max-height: none から閉じる場合も、現在の高さを描画してから 0 にする。
      content.getBoundingClientRect();

      requestAnimationFrame(() => {
        clicked.classList.remove('is-active');
        content.style.maxHeight = '0px';
      });
    } else {
      clicked.classList.add('is-active');
      btn.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
      content.style.maxHeight = `${content.scrollHeight}px`;
    }
  }

  // 「もっと見る」処理 (.js-more-content を表示)
  setupMoreTextListeners() {
    this.moreTextSections.forEach(section => {
      const trigger = section.querySelector('.js-more-trigger');
      const content = section.querySelector('.js-more-content');

      if (trigger && content) {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();

          // トリガーをフェードアウト
          trigger.style.transition = 'opacity 0.3s ease';
          trigger.style.opacity = '0';
          setTimeout(() => {
            trigger.style.display = 'none';
          }, 300);

          // コンテンツをスライドダウン
          content.style.display = 'block';
          content.style.maxHeight = '0';
          content.style.overflow = 'hidden';
          content.style.transition = 'max-height 0.5s ease';

          const height = content.scrollHeight;
          requestAnimationFrame(() => {
            content.style.maxHeight = `${height}px`;
          });
        });
      }
    });
  }
}
